<div class="cm-left-icon">
    <ng-content select="[cm-left-icon]"> </ng-content>
</div>
<div class="cm-text">
    <ng-content select="[cm-text]"> </ng-content>
</div>
<div class="cm-right-icon">
    <ng-content select="[cm-right-icon]"> </ng-content>
</div>
